import {FormControl} from '@mui/material';
import styled from '@emotion/styled';

export const CustomFormControl = styled(FormControl)({
  root: {
    '& label.Mui-focused': {
      color: '#304ffe'
    },
    '& fieldset': {
      borderColor: '#9CB0D9'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#304ffe'
    },
    '& .MuiInput': {
      borderColor: '#9CB0D9'
    },
    '& .Mui-focused': {
      borderColor: '#304ffe'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#9CB0D9'
      },
      '&:hover fieldset': {
        borderColor: '#9CB0D9'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#304ffe'
      }
    }
  }
});
